import React from 'react';
import { Input } from '../Input';
import { Select } from '../Select';
import { FormLabel } from '../FormLabel';

const TIME_UNITS = ['hours', 'days', 'weeks', 'months'] as const;
type TimeUnit = typeof TIME_UNITS[number];

interface FrequencyInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  tooltip?: string;
}

export const FrequencyInput: React.FC<FrequencyInputProps> = ({
  label,
  value,
  onChange,
  error,
  required,
  tooltip
}) => {
  const parseValue = (val: string): { amount: number; unit: TimeUnit } => {
    const match = val.match(/^(\d+)\s*(hours?|days?|weeks?|months?)$/i);
    if (match) {
      const amount = parseInt(match[1], 10);
      let unit = match[2].toLowerCase().replace(/s$/, '') + 's';
      return { 
        amount, 
        unit: unit as TimeUnit 
      };
    }
    return { amount: 1, unit: 'days' };
  };

  const { amount, unit } = parseValue(value);

  const handleAmountChange = (newAmount: number) => {
    onChange(`${newAmount} ${unit}`);
  };

  const handleUnitChange = (newUnit: TimeUnit) => {
    onChange(`${amount} ${newUnit}`);
  };

  return (
    <div className="flex flex-col gap-1">
      <FormLabel label={label} required={required} tooltip={tooltip} />
      <div className="flex gap-2">
        <div className="flex-1">
          <Input
            label=""
            value={amount}
            onChange={handleAmountChange}
            type="number"
            min={1}
            error={error}
          />
        </div>
        <div className="w-32">
          <Select
            label=""
            value={unit}
            onChange={handleUnitChange}
            options={TIME_UNITS}
          />
        </div>
      </div>
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};